/* @flow */
import Form from '../../_.extend';
import type { TFunction } from 'react-i18next';
import type MultipleBrandUploadController from './MultipleBrandUploadController';

export const makeFields = (t: TFunction) => {
  return [
    {
      name: 'instructions',
      label: t('general:reporting.brand_form.multiple.labels.instructions'),
      fields: [
        {
          name: 'info',
          label: '',
          rules: '',
          value: '',
        },
      ],
    },
    {
      name: 'uploadBrands',
      label: t('general:reporting.brand_form.multiple.labels.upload_brands'),
      fields: [
        {
          name: 'includeBrands',
          label: t('general:reporting.brand_form.multiple.labels.include_brands'),
          rules: '',
          value: false,
        },
        {
          name: 'brandsFile',
          label: t('general:labels.file_upload'),
          rules: '',
          value: '',
        },
      ],
    },
    {
      name: 'uploadTradingAccounts',
      label: t('general:reporting.brand_form.multiple.labels.upload_trading_accounts'),
      fields: [
        {
          name: 'includeTradingAccounts',
          label: t('general:reporting.brand_form.multiple.labels.include_trading_accounts'),
          rules: '',
          value: false,
        },
        {
          name: 'tradingAccountsFile',
          label: t('general:labels.file_upload'),
          rules: '',
          value: '',
        },
      ],
    },
  ];
};

class MultipleBrandFormCreate extends Form {}

export const validateUploadSelection = (form: Object, t: TFunction): ?string => {
  const includeBrands = form.$('uploadBrands.includeBrands').value;
  const brandsFile = form.$('uploadBrands.brandsFile').value;
  const includeTradingAccounts = form.$('uploadTradingAccounts.includeTradingAccounts').value;
  const tradingAccountsFile = form.$('uploadTradingAccounts.tradingAccountsFile').value;

  if (!includeBrands && !includeTradingAccounts) {
    return t('general:reporting.brand_form.multiple.messages.select_at_least_one');
  }

  if (includeBrands && !brandsFile) {
    return t('general:reporting.brand_form.multiple.messages.brands_file_required');
  }

  if (includeTradingAccounts && !tradingAccountsFile) {
    return t('general:reporting.brand_form.multiple.messages.trading_accounts_file_required');
  }

  return null;
};

export const multipleBrandUpload = (
  fields: Array<*>,
  localState: Object,
  controller: MultipleBrandUploadController,
  t: TFunction
) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      const validationError = validateUploadSelection(form, t);

      if (validationError) {
        localState.hasError = true;
        localState.hasSuccess = false;
        localState.showResponseMessage = true;
        localState.responseMessage = validationError;
        return Promise.resolve();
      }

      localState.hasError = false;
      localState.showResponseMessage = false;

      const includeBrands = form.$('uploadBrands.includeBrands').value;
      const includeTradingAccounts = form.$('uploadTradingAccounts.includeTradingAccounts').value;

      // Returning this promise keeps mobx-react-form's `form.$submitting` true
      // for the whole preview request (not just until validation resolves),
      // so the submit button stays disabled while the request is in flight.
      return controller.requestPreview({
        brandsFile: includeBrands ? form.$('uploadBrands.brandsFile').value : null,
        tradingAccountsFile: includeTradingAccounts
          ? form.$('uploadTradingAccounts.tradingAccountsFile').value
          : null,
      });
    },
    onError() {
      localState.hasError = true;
      localState.hasSuccess = false;
      localState.showResponseMessage = true;
      localState.responseMessage = t('general:messages.form_error');
    },
  };

  return new MultipleBrandFormCreate(
    { fields },
    { hooks, name: t('general:actions.import_brands') }
  );
};
